import styled, { css } from "styled-components";
import type { LabelVariantsType } from "./Label";

// STYLES
const textIcon = css`
    display: flex;
    column-gap: var(--spacing-2);
    justify-content: space-between;
`;

const formLabel = css`
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-black);
`;

// COMPONENTS
export const LabelVariants = {
    "text-icon": textIcon,
    "form-label": formLabel,
};

const LabelVariant = styled.span<{ variant: LabelVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${LabelVariants[variant]};
        `}
`;

export default LabelVariant;
